module.exports = __webpack_public_path__ + "img/ico-dash-mask.a539a142.svg";